import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  dismissButton: {
    description: 'dismiss button label',
    defaultMessage: 'Dismiss'
  }
});
